export const ADD_SAMPLE_TRIGGER_EVENT = 'addSampleTriggerEvent';
export const SAMPLE_TRIGGER_EVENT_DATA = 'sampleTriggerEventData';
export const TEST_USER = 'testUser';
export const TEST_USER_TYPE = 'testUserType';

export enum TestUserType {
  Email = 'email',
  UserId = 'userId',
}
